<template>
  <div class="container">
    <!-- <img src="../assets/images/bg_mobile.png" /> -->
    <div class="logo">
      <img src="../assets/images/logo_mobile.png" />
      <p>
        {{ title1 }}<br />
        {{ title2 }}
      </p>
    </div>
    <div class="main-logo">
      <img :src="mainLogo" />
    </div>
    <ul>
      <li @click="goPath('https://lawpro.cnki.net/m')">
        <h3>《手机法典》</h3>
      </li>
      <li @click="goPath('https://gw.cnki.net')">
        <h3>《公文大模型》</h3>
      </li>
      <li @click="goPath('https://thinker.cnki.net')">
        <h3>《两会书屋-心可书馆》</h3>
      </li>
      <li @click="goPath('https://aipat.cnki.net')">
        <h3>《知识产权检索分析系统》</h3>
      </li>
      <li @click="goPath('https://cp.cnki.net')">
        <h3>《CNKI公共文化知识资源总库》</h3>
      </li>
      <li>
        <h3 @click="goPath1()">《产业大数据平台》</h3>
      </li>
    </ul>
    <!-- <p class="call">
      {{ call }}
    </p> -->
  </div>
</template>

<script>
import axios from 'axios'
import { pinyin } from 'pinyin-pro'

export default {
  data() {
    return {
      title1: '河北省第十四届人民代表大会第四次会议',
      title2: '政协河北省第十三届委员会第四次会议',
      call: '', //服务热线
      mainLogo: require('@/assets/images/main-logo_mobile.png')
    }
  },
  created() {},
  methods: {
    autosubmit(path) {
      // location.href = path
      // let url = window.location.protocol + '//' + path
      location.href = path
    },
    open(path) {
      location.href = path
    },
    goPath(path) {
      //  window.open(path)
      axios
        .get('/center/auth')
        .then((res) => {
          const token = res.data
          const new_path = `https://my.cnki.net/IntegrateLogin/Redirect.ashx?token=${token}&ReturnUrl=${path}`
          location.href = new_path
        })
        .catch((err) => {
          console.log(err)
        })
    },
    goPath1() {
      axios
        .get('/api/center/auth')
        .then((res) => {
          console.log(res)
          const token = res.data
          const new_path = `https://lianghui.chanyeos.com/smart-ke-b/#/freeLogin?token=${token}&redirect_to=home/homeSearch`
          window.open(new_path)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  mounted() {
    this.$nextTick(() => {
      const { city } = this.$route.query
      let cityName = pinyin(city, { toneType: 'none' })
      let resultCity = cityName.replace(/\s+/g, '')
      this.mainLogo = resultCity
        ? require(`@/assets/images/main-logo_mobile-${resultCity}.png`)
        : require('@/assets/images/main-logo_mobile.png')
      switch (city) {
        case '张家口':
          this.title1 = '张家口市第十五届人民代表大会第九次会议'
          this.title2 = '中国人民政治协商会议张家口市第十四届委员会第五次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'zhangjiakou':
          this.title1 = '张家口市第十五届人民代表大会第九次会议'
          this.title2 = '中国人民政治协商会议张家口市第十四届委员会第五次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case '邯郸':
          this.title1 = '邯郸市第十六届人民代表大会第七次会议‌'
          this.title2 = '中国人民政治协商会议邯郸市第十三届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'handan':
          this.title1 = '邯郸市第十六届人民代表大会第七次会议‌'
          this.title2 = '中国人民政治协商会议邯郸市第十三届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break

        case '承德':
          this.title1 = '承德市第十五届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议承德市第十五届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15230191819'
          break

        case 'chengde':
          this.title1 = '承德市第十五届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议承德市第十五届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15230191819'
          break

        case '秦皇岛':
          this.title1 = ''
          this.title2 = ''
          this.call = '服务热线：400-810-9888、13223439761'
          break
        case 'qinhuangdao':
          this.title1 = ''
          this.title2 = ''
          this.call = '服务热线：400-810-9888、13223439761'
          break
        case '衡水':
          this.title1 = ''
          this.title2 = ''
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'hengshui':
          this.title1 = ''
          this.title2 = ''
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case '廊坊':
          this.title1 = '廊坊市第八届人民代表大会第八次会议'
          this.title2 = '中国人民政治协商会议廊坊市第八届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'langfang':
          this.title1 = '廊坊市第八届人民代表大会第八次会议'
          this.title2 = '政协廊坊市第八届委员会第四次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case '沧州':
          this.title1 = '沧州市第十五届人民代表大会第七次会议'
          this.title2 = '政协沧州市第十二届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15230191819'
          break
        case 'cangzhou':
          this.title1 = '沧州市第十五届人民代表大会第七次会议'
          this.title2 = '政协沧州市第十二届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15230191819'
          break
        case '石家庄':
          this.title1 = '石家庄市第十五届人民代表大会第七次会议‌'
          this.title2 = '中国人民政治协商会议石家庄市第十四届委员会第四次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'shijiazhuang':
          this.title1 = '石家庄市第十五届人民代表大会第七次会议‌'
          this.title2 = '中国人民政治协商会议石家庄市第十四届委员会第四次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case '保定':
          this.title1 = '保定市第十六届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议保定市第十四届委员会第六次会议'
          this.call = '服务热线：400-810-9888、18515055920'
          break
        case 'baoding':
          this.title1 = '保定市第十六届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议保定市第十四届委员会第六次会议'
          this.call = '服务热线：400-810-9888、18515055920'
          break
        case '唐山':
          this.title1 = '唐山市第十六届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议唐山市第十三届委员会第六次会议'
          this.call = '服务热线：400-810-9888、13223439761'
          break
        case 'tangshan':
          this.title1 = '唐山市第十六届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议唐山市第十三届委员会第六次会议'
          this.call = '服务热线：400-810-9888、13223439761'
          break

        default:
          this.title1 = '河北省第十四届人民代表大会第四次会议'
          this.title2 = '政协河北省第十三届委员会第四次会议'
          this.call = ''
          break
      }
    })
  }
}
</script>

<style lang="scss" scoped>
* {
  user-select: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
  cursor: pointer; /*苹果浏览器 点击事件要有此参数*/
}
.container {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background: url('../assets/images/bg_mobile.png') no-repeat;
  background-size: cover;
  img {
    width: 100%;
  }
  .logo {
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    left: 50%;
    transform: translateX(-50%);
    top: 150px;
    width: 100%;
    img {
      width: 350px;
      margin-right: 30px;
    }
    p {
      color: #d91a01;
      font-weight: bold;
      font-size: 65px;
      line-height: 80px;
    }
  }
  .main-logo {
    position: absolute;
    top: 500px;
    width: 1385px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    img {
      width: 100%;
    }
  }
  ul {
    position: absolute;
    top: 1300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 1638px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(180deg, #e61a00 0%, rgba(232, 38, 13, 0.3) 100%);
    height: 1800px;
    border-radius: 120px;
    padding: 70px 0;
    display: flex;
    flex-direction: column;
    gap: 80px;
    li {
      // background: url(~@/assets/images/li_mobile.png) no-repeat;
      background: linear-gradient(270deg, #fef2dd 0%, #f9d9a6 100%);
      border-radius: 100px;
      background-size: 100% 100%;
      width: 1300px;
      height: 205px;
      line-height: 205px;
      font-size: 80px;
      transition: all 0.3s;
      cursor: pointer;
      font-weight: bold;
      color: #d91a01;
      // position: absolute;
      h3 {
        line-height: 205px;
        text-align: center;
      }
      // &:nth-of-type(1) {
      //   left: 50%;
      //   transform: translateX(-50%);
      //   top: 0;
      // }
      // &:nth-of-type(2) {
      //   left: 50%;
      //   transform: translateX(-50%);
      //   top: 295px;
      // }
      // &:nth-of-type(3) {
      //   left: 50%;
      //   transform: translateX(-50%);
      //   top: 590px;
      // }
      // &:nth-of-type(4) {
      //   left: 50%;
      //   transform: translateX(-50%);
      //   top: 885px;
      // }
      // &:nth-of-type(5) {
      //   left: 50%;
      //   transform: translateX(-50%);
      //   top: 1180px;
      // }
    }
  }
  .call {
    position: absolute;
    bottom: 250px;
    left: 50%;
    width: 100%;
    text-align: center;
    transform: translateX(-50%);
    color: #fff1c1;
    padding-left: 40px;
    font-size: 60px;
  }
}
</style>
